<template>
  <div class="tag-autocomplete">
    <form :action="formAction" class="tag-autocomplete__form">
      <div class="tag-autocomplete__form-inner">
        <input
          ref="input"
          type="text"
          name="q"
          class="tag-autocomplete__input input-reset color-2 f4"
          :placeholder="placeholder ? placeholder : translations.searchPlaceholder"
          v-model="query"
          @input="handleInput"
          @keydown="handleKeyDown"
          autocomplete="off"
        />

        <input
          ref="suggestion"
          type="text"
          class="tag-autocomplete__suggestion input-reset color-2 f4"
          autocomplete="off"
          readonly
        />
      </div>

      <button type="submit" class="color-2 bn bg-transparent ph3">
        <svg height="24" viewBox="0 0 28 28" width="24" xmlns="http://www.w3.org/2000/svg">
          <path
            d="m63.2940896 61.0924015 5.2831773 5.2831773c.5896151.5896151.5896151 1.5455701 0 2.1351852l-.0665029.0665029c-.5896151.5896151-1.5455701.5896151-2.1351852 0l-5.2831773-5.2831773c-4.8859968 3.8025504-11.9535024 3.4583142-16.4445252-1.0327086-4.8638351-4.8638351-4.8638351-12.7496697 0-17.6135047 4.863835-4.8638351 12.7496696-4.8638351 17.6135047 0 4.4910228 4.4910228 4.835259 11.5585284 1.0327086 16.4445252zm-3.2343967-1.0327086c3.6478762-3.6478763 3.6478762-9.5622523 0-13.2101285-3.6478763-3.6478763-9.5622523-3.6478763-13.2101285 0-3.6478763 3.6478762-3.6478763 9.5622522 0 13.2101285 3.6478762 3.6478762 9.5622522 3.6478762 13.2101285 0z"
            fill="currentColor"
            transform="translate(-41 -41)"
          />
        </svg>
      </button>
    </form>

    <p class="tag-autocomplete__text f-smallest" :style="`color:${currentColor}`">{{ this.text }}</p>
  </div>
</template>

<script>
import s from "../store"
import h from "../helpers"
import axios from "axios"

export default {
  name: "TagAutocomplete",

  props: {
    formAction: {
      type: String,
      default: "/search"
    },
    placeholder: {
      type: String,
      default: "Start typing..."
    },
    initialQuery: {
      type: String,
      default: ""
    },
    minChars: {
      type: Number,
      default: 2
    },
    text: {
      type: String,
      default: "Room feature, question, anything"
    },
    focus: {
      type: Boolean,
      default: false
    },
    themeSite: String,
    lightBg: {
      type: String,
      default: "false"
    }
  },

  data() {
    return {
      query: this.initialQuery,
      currentColor: null
    }
  },

  mounted() {
    this.getColor()
    if (this.focus) {
      this.$refs.input.focus()
    }
  },

  methods: {
    getColor: function() {
      if (this.lightBg === "true") {
        this.currentColor = s.static.theme[this.themeSite].colors.dark
      } else {
        this.currentColor = s.static.theme[this.themeSite].colors.light
      }
    },
    handleInput: h.debounce(function(e) {
      // reset suggestion till we found new one
      this.$refs.suggestion.value = ""

      if (this.query.length >= this.minChars) {
        this.getData()
      }
    }, 150),

    handleKeyDown(e) {
      const key = e.keyCode
      // Key List
      const DOWN = 40
      const UP = 38
      const ENTER = 13
      const ESC = 27
      const TAB = 9
      // Prevent Default for Prevent Cursor Move & Form Submit
      switch (key) {
        case DOWN:
          e.preventDefault()
          break
        case UP:
          e.preventDefault()
          break
        case TAB:
        case ENTER:
          e.preventDefault()
          if (
            this.$refs.suggestion.value.length > 0 &&
            this.$refs.suggestion.value != this.$refs.input.value
          ) {
            this.$refs.input.value = this.$refs.suggestion.value
          } else if (
            this.$refs.input.value &&
            (this.$refs.suggestion.value.length == 0 ||
              this.$refs.input.value == this.$refs.suggestion.value)
          ) {
            e.target.form.submit()
          }
          break
        case ESC:
          e.preventDefault()
          this.$refs.suggestion.value = ""
          this.$refs.input.value = ""
          break
      }
    },

    getData() {
      const baseUrl = window.Craft.baseUrl

      axios
        .get(`${baseUrl}api/v1/autocomplete.json?q=${this.query}`)
        .then(response => {
          if (response.data && response.data.title.indexOf(this.query) > -1) {
            if (this.$refs.input.value.length) {
              this.$refs.suggestion.value = response.data.title
            }
          }
        })
        .catch(function(error) {
          console.error(error.response)
        })
    }
  }
}
</script>

<style scoped>
.tag-autocomplete {
  position: relative;
}

.tag-autocomplete__form {
  border-bottom: 2px solid #ffffff;
  margin-bottom: 1rem;
  display: flex;
}

.tag-autocomplete__form-inner {
  position: relative;
  flex-grow: 1;
}

.tag-autocomplete__suggestion,
.tag-autocomplete__input {
  outline: 0;
  border: none;
  padding: 1.5rem 0;
  width: 100%;
  background-color: transparent;
}

.tag-autocomplete__input {
  position: relative;
  z-index: 2;
}

.tag-autocomplete__suggestion {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
  opacity: 0.5;
}
</style>
